/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ sets: NonNullable<unknown>, seconds: NonNullable<unknown> }} Plan_Dose_HoldInputs */

const en_us2_plan_dose_hold = /** @type {(inputs: Plan_Dose_HoldInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.sets} × ${i?.seconds} s`)
};

const pt_br2_plan_dose_hold = /** @type {(inputs: Plan_Dose_HoldInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.sets} × ${i?.seconds} s`)
};

const es_419_plan_dose_hold = /** @type {(inputs: Plan_Dose_HoldInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.sets} × ${i?.seconds} s`)
};

const pt_pt2_plan_dose_hold = /** @type {(inputs: Plan_Dose_HoldInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.sets} × ${i?.seconds} s`)
};

const fr_fr2_plan_dose_hold = /** @type {(inputs: Plan_Dose_HoldInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.sets} × ${i?.seconds} s`)
};

const de_de2_plan_dose_hold = /** @type {(inputs: Plan_Dose_HoldInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.sets} × ${i?.seconds} s`)
};

const it_it2_plan_dose_hold = /** @type {(inputs: Plan_Dose_HoldInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.sets} × ${i?.seconds} s`)
};

/**
* | output |
* | --- |
* | "{sets} × {seconds} s" |
*
* @param {Plan_Dose_HoldInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_dose_hold = /** @type {((inputs: Plan_Dose_HoldInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Dose_HoldInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_dose_hold(inputs)
	if (locale === "es-419") return es_419_plan_dose_hold(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_dose_hold(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_dose_hold(inputs)
	if (locale === "de-DE") return de_de2_plan_dose_hold(inputs)
	if (locale === "it-IT") return it_it2_plan_dose_hold(inputs)
	return en_us2_plan_dose_hold(inputs)
});
export { plan_dose_hold as "plan.dose_hold" }